export default __webpack_public_path__ + "static/media/23_photo.3c15df77.jpg";